import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import { observer } from 'mobx-react-lite';

import { useMst } from '../../../models/rootModel';
import { useAnalytics } from '../../../utils/analytics';

import { PickAGroupStepProps } from './pickAGroupStep.types';

import { GroupList } from './GroupList';
import { GroupDetails } from './GroupDetails';

export const PickAGroupStep = observer((props: PickAGroupStepProps) => {
  const { isActive, nextStep, isPopUp } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [pickedGroupId, setPickedGroupId] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const { UserDiscoveryResponse, Group, UserProgress, Step } = useMst();

  const analyticsObj = useRef({
    stepId: props.id,
    stepType: props.type,
    stepIndex: props.stepIndex,
    stepTitle: props.title,
    ...UserDiscoveryResponse.utms,
    origin: Step.origin,
    userID: UserDiscoveryResponse.accountId,
  });

  const analytics = useAnalytics();

  useEffect(() => {
    if (isActive && Group.groups) {
      setIsButtonDisabled(false);
    }
  }, [isActive, Group.groups]);

  useEffect(() => {
    if (isActive && Group.groups.length === 0) {
      analytics.track('start pickAGroup with empty groups', {
        ...analyticsObj,
        discovery: UserDiscoveryResponse.userAnswersObject,
        groups: Group.groups,
      });
      nextStep();
    }
  }, [isActive, Group.groups, nextStep, analytics, UserDiscoveryResponse.userAnswersObject]);

  const openGroupPopUp = (groupId: string) => {
    setPickedGroupId(groupId);
    if (isPopUp) {
      setIsOpen(true);
      return;
    }
    pickedGroup(groupId);
  };

  const pickedGroup = (groupInstanceId: string) => {
    // if no auth token??

    if (UserDiscoveryResponse.authToken || localStorage.getItem('authToken')) {
      setIsButtonDisabled(true);
      UserDiscoveryResponse.assignUserToGroup({ groupInstanceId })
        .then((res) => {
          if (res.kind === 'ok') {
            setIsOpen(false);

            const group = Group.getGroup(groupInstanceId);

            analytics.track(`click pick a group complete`, {
              stepId: props.id,
              stepType: props.type,
              stepIndex: props.stepIndex,
              stepTitle: props.title ?? '',
              groupInstanceId: groupInstanceId,
              meetingDaytime: moment(group?.schedule).format('dddd [at] h:mm a'),
              facilitator: group?.leaderName,
              ...UserDiscoveryResponse.utms,
              origin: Step.origin,
              userID: UserDiscoveryResponse.accountId,
            });

            UserProgress.addStep(props.stepName);

            nextStep();
            return;
          }
          throw new Error(res.data);
        })
        .catch((error) => console.log('error', error));
    }
  };

  const renderPage = () => {
    return !isOpen ? (
      <GroupList openGroupPopUp={openGroupPopUp} {...props} isButtonDisabled={isButtonDisabled} />
    ) : (
      <GroupDetails
        isButtonDisabled={isButtonDisabled}
        pickedGroup={pickedGroup}
        pickedGroupId={pickedGroupId}
        setIsOpen={setIsOpen}
        {...props}
      />
    );
  };

  return <>{isActive ? renderPage() : null}</>;
});
